import {
  ISearchSuggestionResponseKeys,
  ISuggestionEntry,
  ITypedSuggestionEntry,
} from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import * as React from "react";

type Props = {
  sectionHeader: string;
  suggestionArray:
    | ISuggestionEntry[]
    | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[];
  sectionIndex: number;
  trackView: (
    sectionHeader: string,
    suggestionArray:
      | ISuggestionEntry[]
      | ITypedSuggestionEntry<ISearchSuggestionResponseKeys>[],
    sectionIndex: number
  ) => void;
};

export const ResultsDropdownSectionWrapper: React.FC<
  React.PropsWithChildren<Props>
> = ({ children, sectionHeader, suggestionArray, sectionIndex, trackView }) => {
  React.useEffect(() => {
    trackView(sectionHeader, suggestionArray, sectionIndex);
  }, [sectionHeader, suggestionArray, sectionIndex, trackView]);

  return <> {children} </>;
};
